import React, { useContext, useEffect, useState } from 'react'
import ContentSection from '../../Content'
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import BaseUrl from '../../../utils/BaseUrl';
import moment from 'moment';
import separateNumber from '../../../utils/separateur';
import Swal from 'sweetalert2';
import { UserContext } from '../../../utils/User_check';
import can from '../../../utils/Can';
import RuleStepValidation from '../../../utils/step_ruls';
import Select  from 'react-select';
import SwalTopEnd from '../../../utils/swal_top_end';


const url = BaseUrl();
const ApprobationPage = () => {

    const {reference} = useParams();

    const totalSteps = 9;
    const [currentStep, setCurrentStep] = useState();
    const [searchInput,setSearchInput] = useState('');
    const [demandeAsset,setDemandeAsset] = useState(null);
    const [autorisationList,setAutorisationList] = useState([]);
    const [listMaterielTab,setListMaterielTab] = useState([]);
    const [materielList,setMaterielList] = useState([]);
    const [selectMateriel,setSelectMateriel] = useState(null);
    const [error,setError] = useState("");

    const [loading,setLoading] = useState(false);
    const [loadingvalidate,setLoadingvalidate] = useState(false);
    const [loadingrefused,setLoadingvalidaterefused] = useState(false);
    const [loadingmat,setLoadingMat] = useState(false);
    const [loadingcontrat,setLoadingContrat] = useState(false);
    const [loadingcontratsm,setLoadingContratsm] = useState(false);
    const [loadingcontratend,setLoadingcontratend] = useState(false);
    const [articles,setArticles] = useState([]);
    const [selectOptionArticle,setOptionArticle] = useState(null);



    const [urlImg,setUrlImg] = useState();
    const [statusNext,setStatusNext] = useState('');
    const [status,setStatus] = useState('');
    const [stockMaterielMarque,setStockMaterielMarque] = useState(null);
    const {user,permissions} = useContext(UserContext);
    const navigate = useNavigate();

    const [cmtValidate,setCmtValidate] = useState('');
    const [editcontratData,setEditContratData] = useState({
        'nature_piece':'CNI (Carte nationale d\'identité)',
        'numero_piece':'',
        'date_delivrance_piece':'',
        'date_expire_piece':'',
        'nom_proprietaire':'',
        'prenom_proprietaire':''
    });
    const [pieceRectoFile,setpieceRectoFile] = useState(null);
    const [pieceVersoFile,setpieceVersoFile] = useState(null);
    const [contratFile,setContratFile] = useState(null);


  useEffect(()=>{
        getDemandeList();
  },[statusNext,reference,user]);

    const optionmateriels = materielList?.map((option)=>({
        label : `${option.num_serie}`,
        value : option.id
    }));

    const optionarticles = articles?.map((option)=>({
        label : `${option.libelle}`,
        value : option.code
    }));

const handleChangeEditionContrat=(e)=>{
    setEditContratData({
        ...editcontratData,
        [e.target.name]:e.target.value
    })
}

  function getDemandeList(){
        setLoading(true);
        try {
            axios.get(url.base+`/get-demande-by-reference?searchInput=${reference}`,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                setDemandeAsset(resp.data?.demande);
                setAutorisationList(resp.data?.autorisations); 
                setCurrentStep(resp.data?.step);
                setStatusNext(resp.data?.status_next);
                setStatus(resp.data?.status);
                setStockMaterielMarque(resp.data?.stock_materiel_marque_demande);
                setArticles(resp.data?.articles);
            });
        } catch (error) {
            setLoading(false);
        }
  }

    function getDemandeListNext(){
// ,{searchInput:searchInput,step:currentStep +1}
        setLoading(true);
        try {
            axios.get(url.base+`/get-demande-by-reference?searchInput=${reference}&step=${currentStep +1}`,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                goNext();
                setLoading(false);
                setDemandeAsset(resp.data?.demande);
                setAutorisationList(resp.data?.autorisations); 
                setCurrentStep(resp.data?.step);
                setStatusNext(resp.data?.status_next);
                setStatus(resp.data?.status);
                    setStockMaterielMarque(resp.data?.stock_materiel_marque_demande);
            
            })
        } catch (error) {
            setLoading(false);
        }
    }

function getDemandeListPrev(){
        setLoading(true);
        var current = currentStep-1;
        try {
            axios.get(url.base+`/get-demande-by-reference?searchInput=${reference}&step=${current}`,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                setDemandeAsset(resp.data?.demande);
                setAutorisationList(resp.data?.autorisations); 
                setCurrentStep(resp.data?.step);
                setStatusNext(resp.data?.status_next);
                setStatus(resp.data?.status);
                 setStockMaterielMarque(resp.data?.stock_materiel_marque_demande);
                goPrev();
            })
        } catch (error) {
            setLoading(false);
        }
  }

  const validateAssetDemande=()=>{
  
    const _formData = new FormData();
    _formData.append('reference',demandeAsset.reference);
    _formData.append('commentaire',cmtValidate);

    if(cmtValidate == "")
    {
            Swal.fire({
            position: 'top-end',
            icon: 'error',
            title:  "Veuillez laisser un commentaire",
            showConfirmButton: false,
            timer: 5000,
            toast:true,
            position:'top-right',
            timerProgressBar:true
            });
        return ;
    }
      setLoadingvalidate(true);
        try {
            axios.post(url.base+'/validate-asset-demande-phase1',_formData,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title:  "Opération effectuée avec succès !",
                showConfirmButton: false,
                timer: 5000,
                toast:true,
                position:'top-right',
                timerProgressBar:true
                });
                setLoadingvalidate(false);
                getDemandeList();
            }).catch((error)=>{                
                setLoadingvalidate(false);
                Swal.fire({
                    icon: 'error',
                    title:  error.response.data.message,
                    showConfirmButton: false,
                });
            });
        } catch (error) {
            setLoadingvalidate(false);
            console.log(error);
        }
  }


    const validateAssetDemandeAttributionMateriel=(e)=>{
        e.preventDefault();
    const _formData = new FormData();
    _formData.append('reference',demandeAsset.reference);
    _formData.append('materiel_id',selectMateriel);

    if(selectMateriel == null)
    {
            Swal.fire({
            position: 'top-end',
            icon: 'error',
            title:  "Le matériel est obligatoire",
            showConfirmButton: false,
            timer: 5000,
            toast:true,
            position:'top-right',
            timerProgressBar:true
            });
        return ;
    }
      setLoadingvalidate(true);
        try {
            axios.post(url.base+'/validation-attribution-materiel',_formData,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title:  "Opération effectuée avec succès !",
                showConfirmButton: false,
                timer: 5000,
                toast:true,
                position:'top-right',
                timerProgressBar:true
                });
                  window.$("#exampleModalScrollable").modal('hide');
                setLoadingvalidate(false);
                getDemandeList();
            }).catch((error)=>{                
                setLoadingvalidate(false);
                Swal.fire({
                    icon: 'error',
                    title:  error.response.data.message,
                    showConfirmButton: false,
                });
            });
        } catch (error) {
            setLoadingvalidate(false);
            console.log(error);
        }
  }

    const validateAssetDemandeRefused=()=>{
  
    const _formData = new FormData();
    _formData.append('reference',demandeAsset.reference);
    _formData.append('commentaire',cmtValidate);

    if(cmtValidate == "")
    {
            Swal.fire({
            position: 'top-end',
            icon: 'error',
            title:  "Veuillez laisser un commentaire",
            showConfirmButton: false,
            timer: 5000,
            toast:true,
            position:'top-right',
            timerProgressBar:true
            });
        return ;
    }
    console.log(_formData);
      setLoadingvalidaterefused(true);
        try {
            axios.post(url.base+'/validate-asset-refused-phase',_formData,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
            setLoadingvalidaterefused(false);
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title:  "La demande a été réfusée avec succès !",
                showConfirmButton: false,
                timer: 5000,
                toast:true,
                position:'top-right',
                timerProgressBar:true
                });

                getDemandeList();
            }).catch((error)=>{                
                setLoadingvalidaterefused(false);
                Swal.fire({
                    icon: 'error',
                    title:  error.response.data.message,
                    showConfirmButton: false,
                });
                // console.log(error);
            });
        } catch (error) {
            setLoadingvalidaterefused(false);
       
            Swal.fire({
                icon: 'error',
                title:  error.response.data.message,
                showConfirmButton: false,
            });
               
            console.log(error);
        }
  }

  function getListAsset(assetId){
        setLoadingMat(true);
        try {
            axios.get(url.base+'/materiels-available/'+assetId,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                // console.log(resp);
                if(resp.status == 200){
                    setMaterielList(resp.data.data);
                }
                setLoadingMat(false);
                window.$("#exampleModalScrollable").modal('show');
            })
        } catch (error) {
            console.log(error);
            setLoadingMat(false);
        }
  }

    function get_materiel_to_affect(article_id)
    {   if(stockMaterielMarque === null){
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title:  "Nous ne trouvons pas de stock disponible pour le matériel demandé.",
                showConfirmButton: false,
                timer: 5000,
                toast:true,
                position:'top-right',
                timerProgressBar:true
            });
            return;
        }

        getListAsset(article_id);
       
    }

    function submitEditContrat(e){
        e.preventDefault();
        
        if(editcontratData.nature_piece !="" && editcontratData.numero_piece !="" && editcontratData.date_delivrance_piece !="" && editcontratData.date_expire_piece !="" && pieceRectoFile != null){
            const _formData = new FormData();
            _formData.append('nature_piece',editcontratData.nature_piece);
            _formData.append('numero_piece',editcontratData.numero_piece);
            _formData.append('date_delivrance_piece',editcontratData.date_delivrance_piece);
            _formData.append('date_expire_piece',editcontratData.date_expire_piece);
            _formData.append('prenom_proprietaire',editcontratData.prenom_proprietaire);
            _formData.append('nomProprietaire',editcontratData.nom_proprietaire);
            _formData.append('piece_recto',pieceRectoFile);
            _formData.append('piece_verso',pieceVersoFile === null ? "" : pieceVersoFile);
            _formData.append('reference',demandeAsset.reference);
            console.log(_formData);
    
            setLoadingContrat(true);
            try {
            axios.post(`${url.base}/edit-contrat-affectation`,_formData,
            {
                headers:{
                    'Content-Type':'multipart/form-data',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}` 
                    
                },
                responseType:'blob',
                //  credentials:'include'
            }
            ).then((resp)=>{          
                setLoadingContrat(false);
                
                if(resp.status === 200)
                {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download','contrat_pdv.pdf');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    // Swal.fire({
                    //     position: 'top-end',
                    //     icon: 'success',
                    //     title:  "Transfert enregistré avec succès !",
                    //     showConfirmButton: false,
                    //     timer: 5000,
                    //     toast:true,
                    //     position:'top-right',
                    //     timerProgressBar:true
                    //   });

                    window.$("#exampleModalCenteContrat").modal('hide');
                    getDemandeList();
                }else{
                    Swal.fire({
                        icon: 'error',
                        title:  resp.data.message,
                        showConfirmButton: false,
                    });
                }

    
                
            }).catch((error)=>{
            setLoadingContrat(false);
            Swal.fire({
                    icon: 'error',
                    title:  "Désolé un problème est subvenu",
                    showConfirmButton: false,
            });
                console.log(error);
            })
        } catch (error) {
        setLoadingContrat(false);
            Swal.fire({
                    icon: 'error',
                    title:  "Désolé un problème est subvenu",
                    showConfirmButton: false,
            });
            console.log(error.response);
        } 
        }else{
            if(editcontratData.nature_piece == ""){
                SwalTopEnd({icon:"error",title:"Veuillez renseigner la nature de la pièce."});
            }else if(editcontratData.numero_piece == ""){
                SwalTopEnd({icon:"error",title:"Veuillez renseigner le numéro de la pièce."});
            }else if(editcontratData.date_delivrance_piece == ""){
                SwalTopEnd({icon:"error",title:"Veuillez renseigner la date de delivrance de la pièce."});
            }else if(editcontratData.date_expire_piece == ""){
                SwalTopEnd({icon:"error",title:"Veuillez renseigner la date d'expiration de la pièce."});
            }else if(pieceRectoFile === null){
                SwalTopEnd({icon:"error",title:"Veuillez ajouter une pièce d'identité"});
            }
            
        }
    }

    function submitContratTm(e){
        e.preventDefault();
    
    // console.log(askDemande.id);
            if(contratFile != null ){
                const _formData = new FormData();
                _formData.append('contrat_file',contratFile);
                _formData.append('reference',demandeAsset.reference);


                setLoadingContratsm(true);
                try {
                axios.post(`${url.base}/contrat-final-soumettre`,_formData,
                {
                    headers:{
                        'Content-Type':'multipart/form-data',
                        "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                        
                    },
                //    responseType:'blob',
                    //  credentials:'include'
                }
                ).then((resp)=>{          
                    setLoadingContratsm(false);

                        if(resp.status === 200)
                        {
                            Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title:  "Le contrat a été soumis avec succès.",
                                showConfirmButton: false,
                                timer: 5000,
                                toast:true,
                                position:'top-right',
                                timerProgressBar:true
                            });
                            window.$("#exampleModalCenteContratSoumettre").modal('hide');
                        // setErrors({});
                            window.$("#filecontrat").val("");

                            getDemandeList();
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title:  resp.data.message,
                                showConfirmButton: false,
                            });
                        }
                }).catch((error)=>{
                    setLoadingContratsm(false);
                    Swal.fire({
                        icon: 'error',
                        title:  error.response.data.message,
                        showConfirmButton: false,
                    });

                })
            } catch (error) {
            setLoadingContratsm(false);
                console.log(error.response);
            } 
            }else{
                if(contratFile == null){
                    
                    SwalTopEnd({icon:"error",title:"Veuillez ajouter le contrat."});
                }
                
            }
    }


    const cloture_demande_asset = async () => {
         
            Swal.fire({
                title: 'CLÔTURE !',
                text: 'Êtes-vous sûre de vouloir clôturer la demande d\'asset ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonText:"NON",
                confirmButtonText: 'OUI',
                cancelButtonColor:"red"
              }).then((result) => {
                if (result.isConfirmed) {
                    setLoadingvalidate(true);
                    try {
                        axios.post(url.base+'/cloture-demande-asset',{reference:demandeAsset.reference},
                            {
                                headers:{
                                    'Content-Type':'application/json',
                                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                                    
                                },
                            }
                        ).then((resp)=>{
                            setLoadingvalidate(false);
                              Swal.fire(
                                  'Clôturé',
                                  'La demande a été clôturé avec succès !',
                                  'success'
                                )
                               
                        navigate('/affectations/list');
                        }).catch((error)=>{
                            setLoadingvalidate(false);
                            Swal.fire({
                                    icon: 'error',
                                    title:  "Désolé un problème est subvenu",
                                    showConfirmButton: false,
                            });
                                console.log(error);
                            })
                    } catch (error) {
                        setLoadingvalidate(false);
                        console.log(error);
                    }
      
                
                }
              }); 
    }

  const goNext = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  const goPrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

    const open_modal_affect_mat=()=>
    {
        window.$("#exampleModalScrollable").modal('show');
    }

    const handleChangeSelectionArticle=(option)=>{
        setOptionArticle(option.value);
        getListAsset(option.value);
    }

    const handleChangeListMateriel=(option)=>{
            setSelectMateriel(option.value);
            let materiel_choose = materielList.find((materiel)=> materiel.id === option.value);
    
            // console.log(materiel_choose);
        
            if(listMaterielTab.find((list)=> list.materiel_id === materiel_choose.id)){
            console.log("oops")
            }else{
            const itemTable = {
                "materiel_id":materiel_choose.id,
                "image":materiel_choose.materiel.image,
                "marque":materiel_choose?.materiel?.marque?.libelle,
                "num_serie":materiel_choose.num_serie,
                "modele":materiel_choose.materiel?.modele?.libelle,
                "depot_origine_libelle":materiel_choose?.position_materiel[0]?.depot_id !== null ? materiel_choose?.position_materiel[0]?.depot?.name : materiel_choose?.position_materiel[0]?.d_pdv,
                
            }
    
            setListMaterielTab([...listMaterielTab,itemTable]);
            }
    }
    const removeItem = (i) => {
    const updatedMat = [...listMaterielTab];
    updatedMat.splice(i, 1);
    setListMaterielTab(updatedMat);
    };

//   console.log(demandeAsset);
  return (
    <ContentSection ulShownav={"gest-affectations"} navactive={"demandeasset"}>
        <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                        
                        <div class="mb-5">
                            <h3 class="mb-0">
                                Demandes Approbation
                            </h3>
                        </div>
                    </div>
                  
                    
                </div>
                <div className="container my-5">
                    {!loading && demandeAsset !=null &&
                        <>
                            <div className="stepper mx-auto" >
                                <div className="steps d-flex justify-content-between position-relative mb-4">
                                <div
                                    className="position-absolute top-50 start-0 w-100"
                                    style={{ height: "4px", background: "#dee2e6", zIndex: 0 }}
                                ></div>

                                {Array.from({ length: totalSteps }, (_, i) => {
                                    const step = i + 1;
                                    let stepClass = "step d-flex align-items-center justify-content-center rounded-circle fw-bold";
                                    stepClass += " " + (step === currentStep ? "bg-primary text-white scale-110" : "");
                                    stepClass += " " + (step < currentStep ? "bg-success text-white" : step === currentStep ? "bg-warning text-white" : "bg-light text-muted");

                                    return (
                                    <div
                                        key={step}
                                        className={stepClass}
                                        style={{
                                        width: "45px",
                                        height: "45px",
                                        zIndex: 1,
                                        transition: "all 0.3s ease-in-out",
                                        }}
                                    >
                                        {step}
                                    </div>
                                    );
                                })}
                                </div>

                                <div className="stepper-content">
                                        {currentStep <= 9 && (
                                            <div className="card shadow-sm p-4">
                                                <h4 className="mb-3">Étape {currentStep} : 
                                                    {currentStep==1 && <span> CONFIRMATION TM</span>}
                                                    {currentStep==2 && <span> APPROBATION ASM</span>}
                                                    {currentStep==3 && <span> APPROBATION RSM</span>}
                                                    {currentStep==4 && <span> VALIDATION TMC</span>}
                                                    {currentStep==5 && <span> EDITION CONTRAT TM</span>}
                                                    {currentStep==6 && <span> EMISSION CONTRAT TM</span>}
                                                    {currentStep==7 && <span> PREPARATION DE TOURNEE TMC</span>}
                                                    {currentStep==8 && <span> LIVRAISON COMMERCIAL</span>}
                                                    {currentStep==9 && <span> CLOTURE TMC</span>}
                                                    {/* <button class={statusNext == 'En cours'  ? "btn btn-success mx-2 mb-2 float-end disabled" : "btn btn-success mx-2 mb-2 float-end "} type='button' onClick={getDemandeListNext}>SUIVANT</button>
                                                    <button class="btn btn-outline-secondary mx-2 mb-2 float-end" type='button' onClick={getDemandeListPrev}>PRECEDENT</button> */}
                                                    
                                                
                                                
                                                    {currentStep === 4 &&
                                                        <>
                                                        {stockMaterielMarque != null &&
                                                                <div class="alert alert-success mt-4 w-75 text-center" role="alert">
                                                                    Le stock de {stockMaterielMarque.categorie.libelle} de marque {stockMaterielMarque.marque.libelle} est disponible (<Link to={`/stock-by-article/${stockMaterielMarque.uuid}`} class="alert-link">{stockMaterielMarque.stock_materiel_count}</Link>)
                                                                </div>
                                                            }
                                                        {stockMaterielMarque === null &&
                                                            <div class="alert alert-danger mt-4 w-75 text-center" role="alert">
                                                                Le stock de {demandeAsset.categorie.libelle} de marque {demandeAsset.marque.libelle} est indisponible (<Link to="/stock-materiels" class="alert-link">0</Link>)
                                                            </div>
                                                        }
                                                        </>
                                                    }
                                                            
                                                   
                                                </h4>
                                                <div className='row'>

                                                    <div className="col-12 col-md-9">
                                                         <div className="mb-4">
                                                            <div className='card '>
                                                                <div class="card-header">
                                                                    <h4 class="mb-0">Info. Demande Asset</h4>
                                                                </div>
                                                                    <div class="card-body bg-light">
                                                                        <ul class="list-unstyled mb-0">
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Code :</span>
                                                                                <span>{demandeAsset.reference}</span>
                                                                            </li>
                                                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Date de création : </span>
                                                                                <span>{demandeAsset.date ? moment(demandeAsset.date).format('Do MMMM yy HH:mm') : ""}</span>
                            
                                                                            </li>
                            
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Statut actuelle : </span>
                                                                                                {demandeAsset.status == 'En cours' && <span class="badge bg-warning">{demandeAsset.status}</span>}
                                                                                                {demandeAsset.status == 'Validé' && <span class="badge bg-success">{demandeAsset.status}</span>}                                                        
                                                                                                {demandeAsset.status == 'Réfusé' && <span class="badge bg-danger">{demandeAsset.status}</span>}                                                         
                            
                                                                            </li>
                            
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Demandeur : </span>
                                                                                <span >{demandeAsset.addby.use_nom} {demandeAsset.addby?.use_prenom} </span>
                            
                                                                            </li>
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Catégorie demandée :</span>
                                                                                <span>{demandeAsset.categorie.libelle}</span>
                                                                            </li>
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Asset demandé :</span>
                                                                                <span>{demandeAsset.article?.libelle}</span>
                                                                            </li>

                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Capacité Asset demandé :</span>
                                                                                <span>{demandeAsset.article?.capacite?.libelle}</span>
                                                                            </li>
                                                                    
                                                                        <b><u>Description</u></b><br/>
                                                                        <span className="card p-2 mb-3">{demandeAsset.description}</span>
                                                                        {demandeAsset.materiel  &&
                                                                            <>  
                                                                        <b className='text-danger'><u>MATERIEL ATTRIBUE A LA DEMANDE</u></b><br/>

                                                                                <li class="d-flex justify-content-between mb-3 fw-bold mt-2">
                                                                                    {/* <span >Code :</span> */}
                                                                                    <span><img src={`${url.image}/${demandeAsset.materiel.qrcode_path}`} alt="Image"
                                                                                    class="img-4by3-md rounded-3" /></span>
                                                                                </li>

                                                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                    <span>Nom du matériel :</span>
                                                                                    <span>{demandeAsset.materiel.materiel.libelle}</span>
                                                                                </li>

                                                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                    <span>Modèle :</span>
                                                                                    <span>{demandeAsset.materiel.materiel.modele.libelle}</span>
                                                                                </li>
                                                                                <li class="d-flex justify-content-center mb-3 fw-bold">
                                                                                    {/* <span>Image :</span> */}
                                                                                    <span><img src={`${url.image}/${demandeAsset.materiel.materiel.image}`} alt="Image"
                                                                                    class="img-4by3-md rounded-3 " /></span>
                                                                                </li>
                                                                            </>
                                                                        }
                                                                        
                                                                        </ul>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    
                                                         <div className="mb-4">
                                                            <div className='card'>
                                                                <div class="card-header">
                                                                    <h4 class="mb-0">Information PDV</h4>
                                                                </div>
                                                                    <div class="card-body bg-light">
                                                                        <ul class="list-unstyled mb-0">
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Nom :</span>
                                                                                <span>{demandeAsset.d_pdv}</span>
                                                                            </li>
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Contact : </span>
                                                                                <span>{demandeAsset.d_contact}</span>

                                                                            </li>

                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Catégorie PDV : </span>                                                      
                                                                                <span>{demandeAsset.d_pdv_categorie}</span>
                                                                            </li>

                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Adresse PDV : </span>                                                      
                                                                                <span>{demandeAsset.d_addresse}</span>
                                                                            </li>

                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Interlocuteur : </span>                                                      
                                                                                <span>{demandeAsset.interlocuteur} | {demandeAsset.contact}</span>
                                                                            </li>

                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Chiffre d'affaire moyen : </span>                                                      
                                                                                <span className='text-danger'>{separateNumber(demandeAsset.caMoyen)} FCFA</span>
                                                                            </li>
                                                                            <li class="d-flex justify-content-between mb-3 fw-bold">
                                                                                <span>Superficie: </span>                                                      
                                                                                <span className='text-success'>{demandeAsset.superficie} m²</span>
                                                                            </li>

                                                                            <div>
                                                                                <a onClick={()=>{setUrlImg(`${url.image}/${demandeAsset.pdv_onephoto}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${demandeAsset.pdv_onephoto}`} alt="" class="rounded-3 ms-3 me-2 mt-3" width="30%" height="150%" /></a> 
                                                                                <a onClick={()=>{setUrlImg(`${url.image}/${demandeAsset.pdv_twophoto}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${demandeAsset.pdv_twophoto}`} alt="" class=" rounded-3 mt-3"  width="30%" height="150%" /></a> 
                                                                                <a onClick={()=>{setUrlImg(`${url.image}/${demandeAsset.piece_recto}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${demandeAsset.piece_recto}`} alt="" class="rounded-3 mx-3 mt-3"  width="30%" height="150%" /></a> 
                                                                                <a onClick={()=>{setUrlImg(`${url.image}/${demandeAsset.piece_verso}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${demandeAsset.piece_verso}`} alt="" class=" rounded-3 mt-3"  width="30%" height="150%" /></a> 
                                                                            </div>

                                                                    
                                                                        </ul>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card col-3'>
                                                        <div class="card-header">
                                                            <h4 class="mb-0">Actions</h4>
                                                        </div>
                                                            <div class="card-body bg-light">
                                                                <ul class="list-unstyled mb-0">
                                                                    <div>
                                                                        {currentStep <= 7 && RuleStepValidation(currentStep,user?.roles[0].name) && statusNext === 'En cours' &&
                                                                            <>
                                                                                <label>Commentaire</label>
                                                                                <textarea className='form-control mb-3' onChange={(e)=>setCmtValidate(e.target.value)}></textarea>
                                                                            </>
                                                                        }

                                                                        
                                                                        {can(permissions,'Approbation') &&  RuleStepValidation(currentStep,user?.roles[0].name) && statusNext === 'En cours' && 
                                                                            <>
                                                                                {currentStep < 4 &&<button class={loadingvalidate ? "btn btn-success mx-2 w-100 mb-2 disabled" : "btn btn-success mx-2 w-100 mb-2"} onClick={validateAssetDemande}>Valider</button>}
                                                                                {currentStep == 9 &&<button class={loadingvalidate ? "btn btn-success mx-2 w-100 mb-2 disabled" : "btn btn-success mx-2 w-100 mb-2"} onClick={cloture_demande_asset}>Clôturer la demande</button>}
                                                                                {currentStep == 4 && <button class={loadingmat ? "btn btn-success mx-2 w-100 mb-2 disabled" : "btn btn-success mx-2 w-100 mb-2"} onClick={()=>get_materiel_to_affect(stockMaterielMarque?.code)}>{!loadingmat ? `Associer un matériel` : `Chargement en cours...`}</button> }
                                                                            </>
                                                                        }
                                                                        {can(permissions,'Pouvoir editer et soumettre un contrat') && RuleStepValidation(currentStep,user?.roles[0]?.name) && statusNext == 'En cours' &&
                                                                            <>
                                                                               {currentStep == 5 && 
                                                                                    <button class="btn btn-warning mx-2 w-100 mb-2" onClick={()=>{window.$("#exampleModalCenteContrat").modal('show');}}>Editer un contrat</button> 
                                                                               } 
                                                                               {currentStep == 6 && 
                                                                                <button class="btn btn-primary mx-2 w-100 mb-2" onClick={()=>{window.$("#exampleModalCenteContratSoumettre").modal('show');}}>Soumettre le contrat</button>    
                                                                               }
                                                                            </>
                                                                        }
                                                                   
                                                                  {currentStep <= 7 && RuleStepValidation(currentStep,user?.roles[0]?.name) && statusNext === 'En cours' &&<button class={loadingrefused ? "btn btn-danger mx-2 w-100 mb-2 disabled" : "btn btn-danger mx-2 w-100 mb-2"} onClick={validateAssetDemandeRefused}>Rejeter</button> }
                                                                    </div>
                                                                </ul>
                                                            </div>
                                                    </div>
                                                    
                                                </div>

                                                <div class="row mt-3">
                                                        <div class="offset-xxl-12 col-xxl-12 col-md-12 col-12">
                                                        <div class="card" id="invoice">
                                                            <div class="card-header">
                                                                <h4 class="mb-0">Historique de validation</h4>
                                                            
                                                            </div>
                                                            <div class="card-body">                               
                                                        
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="table-responsive ">
                                                                            <table class="table table-centered text-nowrap">
                                                                                <thead class="table-info ">
                                                                                    <tr>
                            
                                                                                    <th scope="col">Etape</th>
                                                                                    <th scope="col">Date</th>
                                                                                    <th scope="col">Auteur</th>
                                                                                    <th scope="col">Rôle auteur</th>
                                                                                    <th scope="col" >Commentaire</th>
                                                                                    <th scope="col">Statut</th>
                            
                                                                                    {/* <th scope="col">Action</th> */}
                                                                                    </tr>
                                                                                </thead>
                                                                                    <tbody>
                                                                                         {autorisationList?.map((item,index)=>
                                                                                        
                                                                                            <tr key={index}>
                            
                                                                                            <td className="text-center fw-bold">{item.step-1}</td>
                                                                                            <td className="fw-bold">{moment(item.created_at).format('Do MMMM YYYY H:mm:s')}</td>
                                                                                            <td className="fw-bold ">{item?.auteur.use_nom} {item?.auteur.use_prenom} ( {item?.auteur.phone} )</td> 
                                                                                            <td className="fw-bold ">{item?.auteur.roles[0].name}</td> 
                                                                                           
                                                                                             <td className="fw-bold">{item.commentaire}</td>
                                                                                            <td className="fw-bold text-danger text-center">
                                                                                                     {item.status == 'En cours' && <span class="badge bg-warning">{item.status}</span>}
                                                                                                    {item.status == 'Validé' && <span class="badge bg-success">{item.status}</span>}                                                        
                                                                                                    {item.status == 'Réfusé' && <span class="badge bg-danger">{item.status}</span>}  
                                                                                            </td> 
                                                                                        </tr>
                                                                                        
                                                                                        )} 
                                                                                    </tbody>
                                                                            </table>
                                                                        </div>
                                                                    
                                                                    </div>
                                                                </div>
                            
                            
                            
                                                                </div>
                                                        </div>
                            
                            
                                                        </div>
                                                </div>
                                            </div>
                                        )}


                                </div>
                            </div>
                        </>
                    }


                    {loading && 
                        <div class="text-center">
                            <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                   
                   {!loading && demandeAsset == null &&
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="mb-5">
                                    <h3 class="mb-0 text-center">Aucun resultat trouvé !</h3>
                                </div>
                            </div>
                        </div>
                   }


                </div>

            </div>


            {/* MODAL */}
            <div class="modal fade" id="exampleModalCente" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">IMAGES</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <img src={urlImg} alt="" class="rounded-3 ms-3 me-2" width="100%" height="150%" />
                        </div>
                    </div>
                    {/* <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                    </div> */}
                </div>
                </div>
            </div>

            <div class="modal fade" id="exampleModalScrollable" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <form class="modal-content" onSubmit={validateAssetDemandeAttributionMateriel}>
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalScrollableTitle">ATTRIBUTION</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div class="modal-body">
                    
                                <div class="modal-body">
                                    <div class="mb-3">
                                    <label class="form-label" for="textInput">Liste des assets </label>
                                    <Select options={optionarticles} onChange={handleChangeSelectionArticle} 
                                        value={optionarticles?.find(obj => obj.value == stockMaterielMarque?.code)}
                                        defaultValue={[{label: stockMaterielMarque?.code == stockMaterielMarque?.code ? optionarticles?.find(obj => obj.value === stockMaterielMarque?.code) : ""}]}
                                    />
                                
                                </div>

                                <div class="mb-3">
                                    <label class="form-label" for="textInput">Selectionner un N°Serie (Resultat : <b className="text-danger">{materielList?.length}</b>) </label>
                                    <Select options={optionmateriels} onChange={handleChangeListMateriel} isDisabled={listMaterielTab.length > 0 ? true : false}/>
                                
                                </div>

                                <div class="row">
                                        <div class="col-12">
                                            <div class="table-responsive ">
                                                <table class="table table-centered text-nowrap">
                                                    <thead class="table-info ">
                                                        <tr>
                                                            <th scope="col">Image</th>
                                                            <th scope="col">N°Serie</th>
                                                            <th scope="col">Marque</th>
                                                            <th scope="col">Modele</th>
                                                            <th scope="col">Dépôt</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        
                                                    {listMaterielTab && 
                                                            listMaterielTab.map((item,index)=>
                                                            <tr key={index}>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                    <a href="#!"><img src={`${url.image}/${item.image}`} alt="Image"
                                                                        class="img-4by3-md rounded-3" /></a>
                                                           
                                                                    </div>
                                                                </td>
                                                                 <td>
                                                                    {item.num_serie}
                                                                </td>
                                                                  <td>
                                                                    <div class="ms-3">
                                                                        <h5 class="mb-0">{item.marque}</h5>                                      
                                                                    </div>
                                                                  </td>

                                                                <td>{item.modele}</td>
                                                                <td>
                                                                {item.depot_origine_libelle}
                                                                </td>
                                                               
                                                                <td className="text-center">
                                                                    <button type="button" className="btn btn-danger btn-sm " onClick={()=>removeItem(index)}> <i className="fa fa-trash"></i> </button>
                                                                </td>
                                                            </tr>
                                                            )
                                                        }
                                                    
                                                        
                                
                                                    </tbody>
                                                    </table>
                                            </div>
                                        
                                        </div>
                                    </div>
                                
                                </div>
                            
                        
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                            {!loadingvalidate && <button type="submit" class={listMaterielTab.length > 0  ? "btn btn-primary" : "btn btn-primary disabled"} >Valider cette attribution</button> }
                            {loadingvalidate && <button type="button" class="btn btn-primary disabled">En Chargement...</button> }
                        </div>
                    </form>
                </div>
            </div>

            
            <div class="modal fade" id="exampleModalCenteContrat" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                <form class="modal-content" onSubmit={submitEditContrat}>
                    <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Editer le contrat</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                    </div>
                    <div class="modal-body">
                        <div className='row'>
                            <div className='col-md-6 mb-3'>
                                <label class="form-label" for="textInput">Nom du propriétaire</label>
                                <input type="text" className="form-control" onChange={handleChangeEditionContrat} name="nom_proprietaire" />
                            </div>

                            <div className='col-md-6 mb-3'>
                                <label class="form-label" for="textInput">Prénoms du propriétaire</label>
                                <input type="text" className="form-control" onChange={handleChangeEditionContrat} name="prenom_proprietaire" />
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label" for="textInput">Nature de la pièce d'identité</label>
                           <select className='form-label form-control' onChange={handleChangeEditionContrat} name='nature_piece'>
                                <option value={"CNI (Carte nationale d'identité)"}>CNI (Carte nationale d'identité)</option>
                                <option value={"Passport"}>Passport</option>
                                <option value={"Permis de conduire"}>Permis de conduire</option>
                                <option value={"Carte Consulaire"}>Carte Consulaire</option>
                           </select>
                        </div>  
                        <div class="mb-3">
                                <label class="form-label" for="textInput">N° de la pièce</label>
                                <input type="text" className="form-control" onChange={handleChangeEditionContrat} name="numero_piece" />
                        </div>  
                        <div className="row">
                            <div class="mb-3 col-md-6">
                                    <label class="form-label" for="textInput">Date de delivrance de la pièce</label>
                                    <input type="date" className="form-control" onChange={handleChangeEditionContrat} name="date_delivrance_piece" />
                            </div>  
                            <div class="mb-3 col-md-6">
                                    <label class="form-label" for="textInput">Date d'expiration de la pièce</label>
                                    <input type="date" className="form-control" onChange={handleChangeEditionContrat} name="date_expire_piece" />
                            </div>  
                        </div>

                        <div className="row">
                            <div class="mb-3 col-md-6">
                                    <label class="form-label" for="textInput">Photo Recto</label>
                                    <input type="file" className="form-control" onChange={(e)=>setpieceRectoFile(e.target.files[0])} />
                            </div> 
                            <div class="mb-3 col-md-6">
                                    <label class="form-label" for="textInput">Photo Verso</label>
                                    <input type="file" className="form-control" onChange={(e)=>setpieceVersoFile(e.target.files[0])} />
                            </div>   
                        </div>
                            
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                        <button type="submit" class={!loadingcontrat ? "btn btn-primary" : "btn btn-primary disabled"}>{!loadingcontrat ? "Télécharger le contrat" : "Téléchargement en cours ..."}</button>
                    </div>
                </form>
                </div>
            </div>

            <div class="modal fade" id="exampleModalCenteContratSoumettre" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-md" role="document">
                <form class="modal-content" onSubmit={submitContratTm}>
                    <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Soumettre le contrat</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                    </div>
                    <div class="modal-body">
                        <div className="row">                           
                            <div class="mb-3 col-md-12">
                                    <label class="form-label" for="textInput">Veuillez Uploader le contrat ici</label>
                                    <input type="file" className="form-control" id="filecontrat" name="contrat_file" onChange={(e)=>setContratFile(e.target.files[0])} accept="application/pdf"/>
                            </div>  
                        </div>
                            
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                        <button type="submit" class={!loadingcontratsm ? "btn btn-primary" : "btn btn-primary disabled"}>{!loadingcontratsm ? "Enregister le contrat" : "Enregistrement en cours..."}</button>
                    </div>
                </form>
                </div>
            </div>


    </ContentSection>
  )
}

export default ApprobationPage